<script>
import EnergyReportForm from '@/components/energy-report-form.vue'

import EnergyReportPreview from '../components/energy-report-preview.vue'
import demoCompanies from '@/assets/data/companies.json'
export default {
  name: 'energy-report-view',
  components: {
    EnergyReportForm,
    EnergyReportPreview,
  },
  data: () => ({
    decoded: {
      company: null,
      title1: null,
      title2: null,
      title3: null,
      titleSavings: null,
      selectedTrailers: [],
      trailers: null,
      usageRange: null,
    },
  }),
  computed: {},
  methods: {},
  created() {
    const encoded = this?.$route?.query?.d || null
    if (!encoded) {
      console.log('NO ENCODED DATA FOUND')
      return
    }
    const decoded = atob(encoded)
    const data = JSON.parse(decoded)
    console.log(data)
    this.decoded = { ...this.decoded, ...data }
  },
}
</script>

<template>
  <!-- <energy-report-form :companies="companies" :selectedTrailers="selectedTrailers"></energy-report-form> -->
  <energy-report-preview v-bind="decoded" class="ma-n4"></energy-report-preview>
</template>

<style scoped></style>
